import { useEffect, useState } from "react";
import { Shield, X, Check } from "lucide-react";
import api from "@/lib/api";

export default function DriverRulesModal({ open, onClose, onAccept, defaultAccepted = false }) {
  const [rules, setRules] = useState([]);
  const [agreed, setAgreed] = useState(defaultAccepted);

  useEffect(() => {
    if (!open) return;
    api.get("/chauffeur/rules").then((r) => setRules(r.data?.rules || []));
  }, [open]);

  if (!open) return null;
  return (
    <div data-testid="driver-rules-modal" className="fixed inset-0 z-50 flex items-center justify-center bg-luxury-black/80 backdrop-blur-sm p-4">
      <div className="bg-luxury-black border border-gold/30 rounded-md max-w-lg w-full p-6 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-white/40 hover:text-white" data-testid="close-rules">
          <X size={18} />
        </button>
        <Shield className="text-gold mb-3" size={24} />
        <p className="text-xs font-body uppercase tracking-[0.2em] text-gold mb-1">Driver Code of Conduct</p>
        <h3 className="font-heading text-2xl text-white mb-4">Read &amp; Agree</h3>
        <ul className="space-y-2 mb-6 max-h-72 overflow-y-auto pr-2">
          {rules.map((r, i) => (
            <li key={i} className="flex items-start gap-2 text-white/80 font-body text-sm">
              <Check size={14} className="text-gold mt-1 shrink-0" />
              <span>{r}</span>
            </li>
          ))}
        </ul>
        <label className="flex items-center gap-2 mb-4 cursor-pointer">
          <input data-testid="rules-checkbox" type="checkbox" checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)} className="accent-gold w-4 h-4" />
          <span className="text-white text-sm font-body">I have read and agree to the Driver Code of Conduct.</span>
        </label>
        <button data-testid="rules-accept-btn" disabled={!agreed} onClick={() => onAccept()}
          className="w-full bg-gold text-luxury-black py-3 font-body text-sm uppercase tracking-wider hover:bg-gold/90 transition-colors disabled:opacity-40">
          Continue
        </button>
      </div>
    </div>
  );
}
